import CharacterCounter from '@stimulus-components/character-counter';

export default CharacterCounter;
